import { useContext } from "react";
import { ModalInsertContext } from "context/ModalInsertContext";
import style from "./Koszt.module.css";
import DecodeToken from "pages/Login/DecodeToken";

export default function KOSZT_ILOSC({ koszt }) {
  const contextModalInsert = useContext(ModalInsertContext);
  const handleKosztyDodatkoweZamowienia = contextModalInsert.handleKosztyDodatkoweZamowienia;
  const ksiegowosc = contextModalInsert.ksiegowosc;
  const setKsiegowosc = contextModalInsert.setKsiegowosc;

  return (
    <td>
      <input
        className={style.nazwa_input}
        type="text"
        value={koszt.ilosc}
        onChange={(event) => {
          const inputValue = event.target.value;
          const re2 = /^[0-9]+$/;

          if (inputValue === "" || re2.test(inputValue)) {
            // 1. Konwersja ilości i ceny na liczby
            const numericIlosc = parseFloat(inputValue) || 0;
            const numericCena = parseFloat(String(koszt.cena).replace(",", ".")) || 0;

            // 2. Obliczenie sumy i zamiana kropki na przecinek pod Excela
            const obliczonaSuma = (numericIlosc * numericCena)
              .toFixed(2)
              .replace(".", ",");

            handleKosztyDodatkoweZamowienia({
              ...koszt,
              ilosc: inputValue,
              suma: obliczonaSuma, // Format np. "3,15"
              zmienil: DecodeToken(sessionStorage.getItem("token"))?.id,
              update: true,
            });
          }
        }}
      />
    </td>
  );
}